module.exports = __webpack_public_path__ + "static/media/Iconly-Light-Delete.686075fa.svg";